import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id C0B4CC94-B6B5-462F-93C2-98F07093614C
 * name message-plus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-plus.svg
 * tags
 */
export const MessagePlusIcon = createSvgIcon(<><path d="M20,2A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H6L2,22V4C2,2.89 2.9,2 4,2H20M11,6V9H8V11H11V14H13V11H16V9H13V6H11Z" /></>, 'MessagePlusIcon');
export default MessagePlusIcon